const configData =  {
	snsList: [
		{name:'Youtube', link:'https://www.youtube.com/channel/UC15smwTxAxbhsyqJm89TDKQ', class:'footer-sns-items-youtube', target:'_blank'},
	],
	menu:[
		{name:'회사소개', link:'https://kr.ncsoft.com/kr/index.do',target:'_blank'},
		{name:'이용약관', link:'https://kr.ncsoft.com/kr/index.do',target:'_blank'},
		{name:'개인정보처리방침', link:'https://kr.ncsoft.com/kr/index.do',target:'_blank'},
		{name:'청소년 보호 정책', link:'https://kr.ncsoft.com/kr/index.do',target:'_blank'},
		{name:'커뮤니티정책', link:'https://kr.ncsoft.com/kr/index.do',target:'_blank'},
	],
	copyrightStudio: 'plaync ® is a registered trademark of NCSOFT Corporation.',
	copyrightCompany: `<span class="long-version">plaync ® is a registered trademark of NCSOFT Corporation.</span>Ⓒ NCSOFT Corporation. All Rights Reserved.`,
	infoAddress: '상호 (주)엔씨소프트 대표 김택진 사업자 등록번호 144-85-04244 통신판매업신고 제2013-경기성남-1268호',
	companyInfo:`<a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1448504244" target="_blank"><strong>사업자정보확인</strong></a>`,
	infoCS : '주소 경기도 성남시 분당구 대왕판교로 644번길 12 모바일게임 고객상담 1566-7004 팩스 02-2186-3499',
	companyEmail: `이메일 <a href="mailto:credit@ncsoft.com" class="email">credit@ncsoft.com</a>`,
	
};

export {
	configData
}